import { numberToHex } from '../../utils/encoding/toHex.js';
export async function setBalance(client, { address, value }) {
    await client.request({
        method: `${client.mode}_setBalance`,
        params: [address, numberToHex(value)],
    });
}
//# sourceMappingURL=setBalance.js.map